import { createCodedError } from '~/common/errors/CodedError';
import { ESigGetIntegrationUsersResponse } from '~/features/admin/ESignature/types';
import { DataWrapper, JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { esignature } from '~/services/serviceInstances';

type Response = ESigGetIntegrationUsersResponse;
interface Request {
  integrationId: string;
}
export async function getEsignatureIntegrationUsers(request: Request) {
  const { integrationId } = request;
  try {
    const { data } = await esignature.get<DataWrapper<Response>>(
      `/integrations/${integrationId}/users`,
    );
    return data;
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors[0];
      throw createCodedError({
        message: errorResponse.detail ?? errorResponse.title,
        statusCode: errorResponse.status,
        title: errorResponse.title,
      });
    }
    throw error;
  }
}
